// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__3kFN5","contactSubtitle":"Contact_contactSubtitle__2a0tc"};